import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Synchronously remove the SEO fallback shell BEFORE React mounts so
// there is no window during which React and the shell compete for the
// same DOM tree. Non-JS crawlers (SEMrush, Bing, LinkedIn) still see
// the shell in the raw HTML because they never execute this script.
const prehydrate = document.getElementById("prehydrate-content");
if (prehydrate && prehydrate.parentNode) {
  prehydrate.parentNode.removeChild(prehydrate);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
